import { useQuery } from '@tanstack/react-query';
import { fetchWordOfDay, type WordOfDayData } from '../api/vocabulary';

const STALE_TIME_MS = 60 * 60 * 1000;

export function wordOfDayQueryKey(grade: number, lessonNo?: number | null) {
  return ['vocabulary', 'word-of-day', grade, lessonNo ?? null] as const;
}

export function useWordOfDay(grade?: number | null, lessonNo?: number | null) {
  const studentGrade =
    grade != null && Number.isFinite(Number(grade)) && grade >= 1 && grade <= 12
      ? Number(grade)
      : undefined;

  return useQuery<WordOfDayData | null>({
    queryKey: wordOfDayQueryKey(studentGrade ?? 0, lessonNo),
    queryFn: () => fetchWordOfDay(studentGrade, lessonNo ?? undefined),
    enabled: studentGrade != null,
    staleTime: STALE_TIME_MS,
    retry: false,
  });
}
